import { ButtonLink, deepLinks } from '@/components';
import webViewService from '@/lib/webViewService';
import { Accordion, Column, Element, Icon, Row } from '@vuddy/components';
import { getClientSideUserAgent, isNonNil } from '@vuddy/utils';
import { isEmpty } from 'lodash-es';
import { Fragment, ReactNode } from 'react';
import * as styles from './purchaseGuideSection.css';

interface SalePagePurchaseGuideSectionsProps {
  title: string;
  sections: { title?: string; description: ReactNode[] }[];
  qna?: { label: string; href: string };
  colorScheme?: 'default' | 'white';
  initialOpen?: boolean;
}

export const SalePagePurchaseGuideSections = ({
  title,
  sections,
  qna,
  colorScheme = 'default',
  initialOpen = false,
}: SalePagePurchaseGuideSectionsProps) => {
  const isAppWebView = webViewService.isAppWebView(getClientSideUserAgent());
  const isWhite = colorScheme === 'white';

  return (
    <Accordion
      gap="gap_3xl"
      initialOpen={initialOpen}
      header={isOpen => (
        <Row
          typography="bodyBaseAccent"
          color={isWhite ? 'whitePrimary' : undefined}
          width="100%"
          alignItems="center"
          justifyContent="space-between">
          {title}
          <Icon name={isOpen ? 'OUTLINE_CHEVRON_UP' : 'OUTLINE_CHEVRON_DOWN'} />
        </Row>
      )}>
      <Column color={isWhite ? 'whiteSecondary' : 'secondary'} gap="gap_3xl">
        {sections.map((section, index) => (
          <Column key={index} gap="gap_base">
            {isNonNil(section.title) && (
              <Element
                typography="bodyXsAccent"
                color={isWhite ? 'whitePrimary' : undefined}>
                {section.title}
              </Element>
            )}
            <Element
              typography="bodyXs"
              color={isWhite ? 'whiteSecondary' : 'tertiary'}
              as="ul"
              className={styles.descriptionUl}>
              {section.description.map((line, index) => (
                <Fragment key={index}>
                  {isEmpty(line) ? (
                    <br />
                  ) : (
                    <li className={styles.descriptionLi}>{line}</li>
                  )}
                </Fragment>
              ))}
            </Element>
          </Column>
        ))}
        {isNonNil(qna) && (
          <ButtonLink
            href={isAppWebView ? deepLinks.openUrl(qna.href) : qna.href}
            variant="outlineSecondary"
            fullWidth>
            {qna.label}
          </ButtonLink>
        )}
      </Column>
    </Accordion>
  );
};
